/*
 * @Description:
 * @Author: lanzhisheng
 * @Date: 2023-03-01 14:09:35
 * @LastEditTime: 2023-05-17 18:17:51
 * @LastEditors: lanzhisheng
 */
export const parseQueryString = (url) => {
  var result = {};
  if (url.indexOf("?") > -1) {
    var str = url.split("?")[1];
    var temp = str.split("&");
    for (var i = 0; i < temp.length; i++) {
      var temp2 = temp[i].split("=");
      result[temp2[0]] = temp2[1];
    }
  }
  return result;
};

//   local debug
let baseUrl = "";
if (process.env.NODE_ENV === "development") {
  // baseUrl = "http://s05.prod.meix.com:5004/wechat";
  baseUrl = "http://127.0.0.1:5000/wechat";
  // baseUrl = "http://172.16.4.133:5002/wechat";
}else if ( process.env.REACT_APP_NOT_SECRET_CODE === "sit") {
  // baseUrl = "http://s05.prod.meix.com:5004/wechat";
  baseUrl = "http://s05.prod.meix.com:5004/wechat";
  // baseUrl = "http://172.16.4.133:5002/wechat";
}else if (process.env.NODE_ENV === "production") {
    // server
  baseUrl = "http://s05.prod.meix.com:5003/wechat";
}
export const domain = baseUrl;

export const opt_products = [
  { value: "option-1676102769407", label: "易直销-SaaS" },
  { value: "option-1689057861821", label: "易运营-SaaS" },
  { value: "option-1676102769408", label: "易直销-项目" },
  { value: "option-1713578785370", label: "易运营-项目" },
  { value: "option-1676103106389", label: "非现场签约&AI双录系统" },
  { value: "option-1676103113054", label: "托管端管理人服务系统" },
  { value: "option-1676103143367", label: "持有人服务平台" },
  { value: "option-1676103144186", label: "易投研（Map）" },
  { value: "option-1729677757456", label: "易风控（Map）" },
  { value: "option-1676103159334", label: "MAP-项目" },
  { value: "option-1676103160239", label: "每市指数" },
  { value: "option-1676103174911", label: "每市中台" },
  { value: "option-1676103175839", label: "每市研究所服务" },
  { value: "option-1676786071278", label: "电话会议通讯&服务" },
  { value: "option-1676103192269", label: "易报表-SaaS" },
  { value: "option-1676103199879", label: "易报表-项目" },
  { value: "option-1676785887046", label: "易股权系统-SaaS&项目" },
  { value: "option-1676785907280", label: "易合规系统" },
  { value: "option-1676785931638", label: "私募智能尽调与跟踪系统-SaaS" },
  { value: "option-1676785934048", label: "营销服务系统-项目" },
  { value: "option-1676800420862", label: "FOF-SaaS" },
  { value: "option-1676800471549", label: "FOF-项目" },
  { value: "option-1676785940168", label: "数据网关服务" },
  { value: "option-1677475869568", label: "电签中台" },
  { value: "option-1678768525349", label: "交易网关" },
  { value: "option-1678768537506", label: "投资交易系统" },
  { value: "option-1690159062663", label: "预估值系统" },
];


export const opt_type = [
  { value: "option-1676783759525", label: "线上问题" },
  { value: "option-1676783759524", label: "需求" },
  { value: "option-1676785033824", label: "任务" },
  { value: "option-1676785038759", label: "其它" },
  { value: "option-1676785019747", label: "客户运营服务" },
  { value: "option-1711015060662", label: "客户运营服务客诉" },
  { value: "option-1689057899982", label: "产品客诉" },
];

export const opt_module = [
  // { value:"option-1676103442875",label:  "无"},
  { value: "option-1676103442876", label: "电签-实名认证" },
  { value: "option-1676786365037", label: "电签-协议模板" },
  { value: "option-1676786369094", label: "电签-签约流程-合格投资认定" },
  { value: "option-1676786373870", label: "电签-签约流程-认申赎签约" },
  { value: "option-1680313169647", label: "电签-签约用印" },
  { value: "option-1676786378638", label: "电签-双录" },
  { value: "option-1676786395000", label: "信批-TA数据对接" },
  { value: "option-1676786397726", label: "其他" },
  { value: "option-1676786408197", label: "门户建站" },
  // { value: "option-1676103442875", label: "无" },
  // { value: "option-1676103442876", label: "电签-实名认证" },
  // { value: "option-1676786365037", label: "电签-协议模板" },
  // { value: "option-1676786369094", label: "电签-签约流程" },
  // { value: "option-1676786373870", label: "电签-签约用印" },
  // { value: "option-1676786378638", label: "电签-双录" },
  // { value: "option-1676786385464", label: "电签-其他" },
  // { value: "option-1676786390421", label: "信披-TA" },
  // { value: "option-1676786395000", label: "信披-数值类（非TA）" },
  // { value: "option-1676786397726", label: "信披-非数值类" },
  // { value: "option-1676786401326", label: "账号管理" },
  // { value: "option-1676786408197", label: "建站" },
  // { value: "option-1676786409969", label: "管理人后台维护" },
  // { value: "option-1676786413903", label: "打新" },
  // { value: "option-1676786418230", label: "其他" },
];
export const opt_level = [
  { value: "option-1676783782093", label: "1" },
  { value: "option-1676785110983", label: "2" },
  { value: "option-1676783782092", label: "3" },
  { value: "option-1676785112409", label: "4" },
];

export const opt_probability = [
  { value: "option-1682237882315", label: "无" },
  { value: "option-1682237882316", label: "5" },
  { value: "option-1682237901720", label: "25" },
  { value: "option-1682237904735", label: "50" },
  { value: "option-1682237910464", label: "75" },
  { value: "option-1682237913152", label: "90" },
  { value: "option-1682237915887", label: "100" },
];

export const opt_isKeyPoint = [
  { value: "option-1682237932456", label: "不是" },
  { value: "option-1682237932457", label: "是" },
];

// 客户注册业务类型
export const opt_ar_busType = [
  { value: "10", label: "试用客户上线" },
  { value: "11", label: "正式客户上线" },
];

// 1.已备案私募管理人，2.持牌金融机构，3.其他
export const opt_ar_companyType = [
  { value: "1", label: "已备案私募管理人" },
  { value: "2", label: "持牌金融机构" },
  { value: "3", label: "其他" },
];

// 客户延期增购业务类型
export const opt_ap_busType = [
  // { value: "20", label: "试用延期" },
  { value: "21", label: "增购" },
];

// 客户启用停止类型
export const opt_apause_busType = [
  { value: "30", label: "停用" },
  { value: "31", label: "启用" },
];


export const opt_need_ob = [
  { value: "option-1740733903704", label: "不需要" },
  { value: "option-1740733903705", label: "需要（对接客户真实数据）" },
];

// 设计需求选项
export const opt_isdesgin = [
  { value: "option-1680323450873", label: "不需要" },
  { value: "option-1680323450874", label: "官网设计" },
  { value: "option-1680323472722", label: "公众号设计" },
  { value: "option-1680323480945", label: "官网 + 公众号设计" },
];

// 设计模板选项
export const opt_design_template = [
  { value: "option-1680323618825", label: "模版A" },
  { value: "option-1680323618826", label: "模版B" },
  { value: "option-1680323668800", label: "模版C" },
  { value: "option-1680323745120", label: "ABC(无法满足需估工作量)" },
];

// 路演状态选项
export const opt_roadshow = [
  { value: "option-1676980655727", label: "已路演" },
  { value: "option-1676980655728", label: "未路演" },
];

// FOF类型选项
export const opt_fof_type = [
  { value: "option-1705315577676", label: "机构投资者" },
  { value: "option-1705315577677", label: "产品投资者" },
];

// YZG环境选项
export const opt_yzg_environment = [
  { value: "option-1688037250053", label: "仿真系统" },
  { value: "option-1688037250054", label: "正式环境" },
];

// 试用期时长选项
export const opt_demo_period = [
  { value: "option-1678266571734", label: "半个月" },
  { value: "option-1711971213200", label: "1 个月" },
  { value: "option-1678266571735", label: "2 个月" },
  { value: "option-1678266618093", label: "3 个月" },
  { value: "option-1711971227793", label: "合同已签订（根据合同时间）" },
];

// 高域系统账号开通选项
export const opt_high_domain = [
  { value: "option-1735891775325", label: "开通" },
  { value: "option-1735891775326", label: "不开通" },
];

// 付费情况确认选项
export const opt_pay_status = [
  { value: "option-1689142056405", label: "已支付费用(平台合同已含版权费)" },
  { value: "option-1689142056406", label: "已支付版权费用" },
  { value: "option-1711971640652", label: "未付费" },
];

// 模拟VIP选项
// export const opt_simu_vip_bak = [
//   { value: "option-1695636587761", label: "易直销 - 基础版 19800" },
//   { value: "option-1695636587762", label: "易直销 - 高级版 39800" },
//   { value: "option-1695636660429", label: "易直销 - 豪华版 59800" },
//   { value: "option-1695636665384", label: "易运营 - 基础版 39800" },
//   { value: "option-1695636672592", label: "易运营 - 高级版 59800" },
//   { value: "option-1711970984769", label: "搭建官网 & 公众号" },
//   { value: "option-1711970985596", label: "易报表" },
//   { value: "option-1711970993051", label: "友商系统切换" },
//   { value: "option-1719813049947", label: "易直销 - 电子签约基础版" },
//   { value: "option-1735891716562", label: "易直销 - 直播模块" },
// ];
export const opt_simu_vip = [
  { value: "option-1695636587761", label: "易私慕电子签约版" },
  { value: "option-1695636587762", label: "易直销运营（私募版）" },
  { value: "option-1695636660429", label: "易直销运营（期货资管版）" },
  { value: "option-1695636665384", label: "打新模块RPA" },
  { value: "option-1695636672592", label: "直播模块" },
  { value: "option-1711970993051", label: "友商系统切换" },
];


// 产品选项
export const opt_product = [
  { value: "option-1711969275366", label: "易直销运营系统-SaaS" },
  { value: "option-1711969275367", label: "易资管系统-SaaS" },
  { value: "option-1711970763812", label: "易估值系统-SaaS" },
  { value: "option-1742290167142", label: "易报表-SaaS" },
  { value: "option-1711970763482", label: "易投研-SaaS" },
  { value: "option-1711970762667", label: "易风控-SaaS" },
  { value: "option-1743651134485", label: "电签服务（电子合同及双录费用）" },
  { value: "option-1711970762091", label: "易合规系统" },
  { value: "option-1711970814321", label: "易股权-SaaS&项目（含周边服务）" },
  { value: "option-1711970817388", label: "每市指数" },
  { value: "option-1711970816876", label: "FOF交易系统" },
  { value: "option-1711970825864", label: "私募智能尽调与跟踪系统（SAAS）" },

];   

export function getOptionLabel(options, value) {
  for (let i = 0; i < options.length; i++) {
    if (options[i].value === value) {
      return options[i].label;
    }
  }
  return "";
}

export function getOptionValue(options, label) {
  for (let i = 0; i < options.length; i++) {
    if (options[i].label.toLowerCase() === label.toLowerCase()) {
      return options[i].value;
    }
  }
  return "";
}
export function getOptionValues(options) {
  return options.map(option => option.value);
}

export function getOptionlabels(options) {
  return options.map(option => option.label);
}